import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TextArea from 'antd/es/input/TextArea';
import { Form, Input, Select } from 'antd';
import TranspForm, { getDefaultTransp } from './TranspForm';
import CobrancaForm from './CobrancaForm';
import { api } from '../../../config/api';

const { Option } = Select;

const Parametros = ({
  isVisible,
  onClose,
  precoTotal,
  setPagamentoConcluido,
  setPagItem,
  pagamentos,
  setPagamentos,
  indPag,
  setIndPag,
  parametros,
  setParametros,
  mostrarCobranca,
  setMostrarCobranca
}) => {
  const [accessToken, setAccessToken] = useState('');
  const [idUser, setIdUser] = useState('');
  const [restauranteId, setRestauranteId] = useState('');
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [totalPago, setTotalPago] = useState(0);
  const [formaDePagamentoSelecionada, setFormaDePagamentoSelecionada] = useState('01');
  const [valor, setValor] = useState(`R$ ${(parseFloat(precoTotal) - parseFloat(totalPago)).toFixed(2)}`);
  const [infCpl, setInfCpl] = useState(parametros?.infCpl || '');
  const [transp, setTransp] = useState(getDefaultTransp());
  const [numeroPedido, setNumeroPedido] = useState("");

  const [dataEmissao, setDataEmissao] = useState(
    new Date().toISOString().split('T')[0]
  );




  const [fatura, setFatura] = useState({
    vLiq: precoTotal,
    vDesc: 0,
    vOrig: precoTotal,
    nFat: '001',
  });


  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const userId = localStorage.getItem('idUsuario');
    setAccessToken(token || '');
    setIdUser(userId || '');
  }, []);

  useEffect(() => {
    if (accessToken && idUser) {
      const fetchRestaurante = async () => {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };
        try {
          const response = await axios.get(
            `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
            options
          );
          setRestauranteId(response.data.id);
        } catch (error) {
          console.error(error);
        }
      };
      fetchRestaurante();
    }
  }, [accessToken, idUser]);

  useEffect(() => {
    if (accessToken && restauranteId) {
      const fetchFormasPagamento = async () => {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };
        try {
          const response = await axios.get(
            `${api.techspdv}/v1/restaurantes/${restauranteId}/formas-pagamento`,
            options
          );
          const formas = response.data._embedded.formasPagamento.map(forma => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(formas);
        } catch (error) {
          console.error(error);
        }
      };
      fetchFormasPagamento();
    }
  }, [accessToken, restauranteId]);

  useEffect(() => {
    setValor(`R$ ${(parseFloat(precoTotal) - parseFloat(totalPago)).toFixed(2)}`);
  }, [precoTotal, totalPago]);

  const tratarValor = (text) => {
    let valorFormatado = text.replace(/\D/g, '');

    if (valorFormatado === '' || parseInt(valorFormatado) === 0) {
      setValor('R$ 0');
    } else {
      valorFormatado = parseFloat(valorFormatado) / 100;
      setValor(
        valorFormatado.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })
      );
    }
  };
  const formatarDataEmissao = (dataSelecionada) => {
    if (!dataSelecionada) {
      return null;
    }

    const agora = new Date();

    const dataUtcMenos3 = new Date(
      agora.getTime() - 3 * 60 * 60 * 1000
    );

    const horas = String(
      dataUtcMenos3.getUTCHours()
    ).padStart(2, '0');

    const minutos = String(
      dataUtcMenos3.getUTCMinutes()
    ).padStart(2, '0');

    const segundos = String(
      dataUtcMenos3.getUTCSeconds()
    ).padStart(2, '0');

    return `${dataSelecionada}T${horas}:${minutos}:${segundos}`;
  };
  const salvarParametros = async () => {
    const dataEmissaoFormatada =
      formatarDataEmissao(dataEmissao);

    const novosParametros = {
      ...parametros,
      infCpl,
      transp:
        transp.modFrete == 9
          ? {
            modFrete: '9',
          }
          : transp,
      NumeroPedido: numeroPedido || null,
      dataEmissao: dataEmissaoFormatada,
      ...(mostrarCobranca
        ? {
          cobr: fatura,
        }
        : {
          cobr: null,
        }),
    };

    console.log(
      'Parâmetros salvos:',
      novosParametros
    );

    setParametros(novosParametros);
    onClose();
  };
  return (
    isVisible && (
      <div style={estiloPaginaParametros}>
        <div style={estiloCardPrincipal}>
          {/* Cabeçalho */}
          <div style={estiloCabecalhoParametros}>
            <div>
              <h3 style={estiloTituloParametros}>
                Parâmetros da Nota
              </h3>

              <span style={estiloDescricaoParametros}>
                Configure pagamento, cobrança, transporte e informações
                complementares.
              </span>
            </div>

            <button
              type="button"
              onClick={onClose}
              style={estiloBotaoFechar}
            >
              ← Voltar
            </button>
          </div>

          <div style={estiloGridParametros}>
            {/* Pagamento e pedido */}
            <div style={estiloCardPagamento}>
              <h4 style={estiloTituloSecao}>
                💳 Pagamento e pedido
              </h4>

              <div style={estiloCampo}>
                <label style={estiloLabel}>
                  Indicador de pagamento
                </label>

                <select
                  style={estiloSelect}
                  value={indPag}
                  onChange={(e) =>
                    setIndPag(e.target.value)
                  }
                >
                  <option value="0">
                    Pagamento à vista
                  </option>

                  <option value="1">
                    Pagamento a prazo
                  </option>

                  <option value="2">
                    Outros
                  </option>
                </select>
              </div>

              {/* Data de emissão */}
              <div
                style={{
                  ...estiloCampo,
                  marginTop: '12px',
                }}
              >
                <label style={estiloLabel}>
                  Data de emissão
                </label>

                <Input
                  className="input-estilizado"
                  style={estiloInputPedido}
                  type="date"
                  value={dataEmissao}
                  onChange={(e) =>
                    setDataEmissao(e.target.value)
                  }
                />
              </div>

              {/* Número do pedido */}
              <div
                style={{
                  ...estiloCampo,
                  marginTop: '12px',
                }}
              >
                <label style={estiloLabel}>
                  Número do pedido
                </label>

                <Input
                  className="input-estilizado"
                  style={estiloInputPedido}
                  value={numeroPedido}
                  onChange={(e) => {
                    // Mantém apenas números e preserva zeros à esquerda
                    const onlyNumbers =
                      e.target.value.replace(/\D/g, '');

                    setNumeroPedido(onlyNumbers);
                  }}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={20}
                  placeholder="Ex: 000123"
                />
              </div>
            </div>

            {/* Observação */}
            <div style={estiloCardObservacao}>
              <h4 style={estiloTituloSecao}>
                📝 Observação da DANFE
              </h4>

              <TextArea
                style={estiloTextArea}
                value={infCpl}
                onChange={(e) =>
                  setInfCpl(e.target.value)
                }
                maxLength={5000}
                showCount
                autoSize={{
                  minRows: 9,
                  maxRows: 9,
                }}
                placeholder="Informações complementares da nota..."
              />
            </div>

            {/* Transporte */}
            <div style={estiloCardLarguraTotal}>
              <h4 style={estiloTituloSecao}>
                🚚 Transporte
              </h4>

              <TranspForm
                value={transp}
                onChange={setTransp}
              />
            </div>

            {/* Cobrança */}
            <div style={estiloCardLarguraTotal}>
              <h4 style={estiloTituloSecao}>
                🧾 Cobrança
              </h4>

              <CobrancaForm
                fatura={fatura}
                setFatura={setFatura}
                value={transp}
                mostrarCobranca={mostrarCobranca}
                setMostrarCobranca={setMostrarCobranca}
                precoTotal={precoTotal}
              />
            </div>
          </div>

          {/* Rodapé */}
          <div style={estiloRodapeParametros}>
            <button
              type="button"
              onClick={onClose}
              style={estiloBotaoFechar}
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={salvarParametros}
              style={estiloBotaoSalvar}
            >
              ✓ Salvar parâmetros
            </button>
          </div>
        </div>
      </div>
    )
  );
};

const estiloCardSecao = {
  padding: '14px',
  background: '#f8fafc',
  border: '1px solid #e5e7eb',
  borderRadius: '12px',
  boxSizing: 'border-box',
};

const estiloGridParametros = {
  display: 'grid',
  gridTemplateColumns:
    'minmax(280px, 340px) minmax(0, 1fr)',
  gap: '12px',
  alignItems: 'stretch',
};

const estiloCardPagamento = {
  ...estiloCardSecao,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
};

const estiloCardObservacao = {
  ...estiloCardSecao,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
};

const estiloPaginaParametros = {
  width: '100%',
  padding: '16px',
  background: '#f4f6f9',
  boxSizing: 'border-box',
};

const estiloCardPrincipal = {
  width: '100%',
  maxWidth: '1350px',
  margin: '0 auto',
  padding: '18px',
  background: '#ffffff',
  border: '1px solid #e5e7eb',
  borderRadius: '16px',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  boxSizing: 'border-box',
};

const estiloCabecalhoParametros = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  paddingBottom: '14px',
  marginBottom: '14px',
  borderBottom: '1px solid #e5e7eb',
};

const estiloTituloParametros = {
  margin: 0,
  color: '#111827',
  fontSize: '21px',
  fontWeight: '800',
};

const estiloDescricaoParametros = {
  display: 'block',
  marginTop: '3px',
  color: '#6b7280',
  fontSize: '13px',
};




const estiloCardLarguraTotal = {
  gridColumn: '1 / -1',
  padding: '14px',
  background: '#f8fafc',
  border: '1px solid #e5e7eb',
  borderRadius: '12px',
  boxSizing: 'border-box',
};

const estiloTituloSecao = {
  display: 'flex',
  alignItems: 'center',
  gap: '7px',
  margin: '0 0 12px',
  color: '#374151',
  fontSize: '14px',
  fontWeight: '800',
};

const estiloCampo = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  width: '100%',
};

const estiloLabel = {
  color: '#374151',
  fontSize: '12px',
  fontWeight: '700',
};

const estiloSelect = {
  width: '100%',
  height: '42px',
  padding: '0 11px',
  background: '#ffffff',
  border: '1px solid #d1d5db',
  borderRadius: '9px',
  color: '#111827',
  fontSize: '14px',
  outline: 'none',
  cursor: 'pointer',
  boxSizing: 'border-box',
};

const estiloInputPedido = {
  width: '100%',
  height: '42px',
  padding: '0 11px',
  background: '#ffffff',
  border: '1px solid #d1d5db',
  borderRadius: '9px',
  color: '#111827',
  fontSize: '14px',
  outline: 'none',
  boxSizing: 'border-box',
};

const estiloTextArea = {
  width: '100%',
  borderRadius: '9px',
  resize: 'vertical',
};

const estiloRodapeParametros = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '10px',
  paddingTop: '15px',
  marginTop: '14px',
  borderTop: '1px solid #e5e7eb',
};

const estiloBotaoBase = {
  minHeight: '42px',
  padding: '9px 18px',
  borderRadius: '9px',
  fontSize: '14px',
  fontWeight: '800',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
};

const estiloBotaoSalvar = {
  ...estiloBotaoBase,
  minWidth: '150px',
  border: '1px solid #000000',
  background: 'linear-gradient(135deg, #27272a, #000000)',
  color: '#ffffff',
  boxShadow: '0 5px 12px rgba(0, 0, 0, 0.2)',
};

const estiloBotaoFechar = {
  minWidth: '110px',
  minHeight: '42px',
  padding: '9px 18px',
  border: '1px solid #dc2626',
  borderRadius: '9px',
  background: 'linear-gradient(135deg, #ef4444, #b91c1c)',
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: '800',
  cursor: 'pointer',
  boxShadow: '0 5px 12px rgba(220, 38, 38, 0.20)',
};


export default Parametros;
